/* Homepage slideshow ↔ tournament calendar sync.
   Each tournament slide's subheading shows the NEXT UPCOMING event that matches the
   slide's game/category, pulled live from the Tournaments page data (the JSON the
   tournament-calendar section embeds on /pages/details). Add a tournament to the
   calendar and the matching homepage slide updates itself — no theme edits needed.
   Slides with no upcoming match show "To Be Announced" (a slide whose static
   subheading is real info, like the weekly Pokémon Play schedule, keeps it). */
(function () {
  var TBA = 'To Be Announced';
  /* keyword → matches a slide when its HEADING contains the keyword, and an event
     when the event's game or title contains it (both diacritic/case-insensitive) */
  var KEYS = ['lorcana', 'riftbound', 'one piece', 'union arena', 'pokemon', 'panini', 'topps', 'trade night', 'magic'];

  function norm(s) {
    return (s || '')
      .toLowerCase()
      .normalize('NFD')
      .replace(/[̀-ͯ]/g, ''); /* Pokémon → pokemon */
  }

  function localDate(ymd) {
    /* '2026-07-21' (or single-digit '2026-7-21') as LOCAL midnight
       (new Date(str) would parse as UTC) */
    var p = /^(\d{4})-(\d{1,2})-(\d{1,2})$/.exec((ymd || '').trim());
    return p ? new Date(+p[1], +p[2] - 1, +p[3]) : null;
  }

  function storeToday() {
    /* events live in LA — cut them over on the STORE's calendar day, not the
       viewer's (an East Coast viewer's midnight is 9pm in Burbank) */
    try {
      return localDate(new Intl.DateTimeFormat('en-CA', { timeZone: 'America/Los_Angeles' }).format(new Date()));
    } catch (e) {
      var n = new Date(); n.setHours(0, 0, 0, 0); return n;
    }
  }

  var DAYS = ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'];
  var MONTHS = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];
  function fmt(ev) {
    var d = ev.d;
    var s = DAYS[d.getDay()] + ', ' + MONTHS[d.getMonth()] + ' ' + d.getDate();
    if (ev.time) s += ' · ' + ev.time;
    return s;
  }

  function run() {
    var comps = document.querySelectorAll('slideshow-component');
    var comp = null;
    for (var i = 0; i < comps.length; i++) {
      if (comps[i].querySelector('.banner__heading')) { comp = comps[i]; break; }
    }
    if (!comp) return;

    fetch('/pages/details')
      .then(function (r) { return r.ok ? r.text() : Promise.reject(); })
      .then(function (html) {
        var doc = new DOMParser().parseFromString(html, 'text/html');
        var dataEl = doc.querySelector('[data-tournaments]');
        var events = [];
        try { events = JSON.parse(dataEl ? dataEl.textContent : '[]'); } catch (e) {}

        var today = storeToday();
        var upcoming = [];
        for (var i = 0; i < events.length; i++) {
          var d = localDate(events[i].date);
          if (!d) continue;
          // a multi-day event stays current until its END date passes (matching the
          // calendar page), not just its start date
          var end = localDate(events[i].endDate) || d;
          if (end >= today) upcoming.push({ d: d, time: events[i].time, hay: norm((events[i].game || '') + ' ' + (events[i].title || '')) });
        }
        upcoming.sort(function (a, b) { return a.d - b.d; });

        var slides = comp.querySelectorAll('.slideshow__slide');
        for (var s = 0; s < slides.length; s++) {
          var headingEl = slides[s].querySelector('.banner__heading');
          var subEl = slides[s].querySelector('.banner__text');
          if (!headingEl || !subEl) continue;
          var heading = norm(headingEl.textContent);
          var key = null;
          for (var k = 0; k < KEYS.length; k++) {
            if (heading.indexOf(KEYS[k]) !== -1) { key = KEYS[k]; break; }
          }
          if (!key) continue; /* not a tournament slide we recognize */
          /* first upcoming event for this game (the status/full model was retired —
             availability is confirmed on the external signup page) */
          var match = null;
          for (var u = 0; u < upcoming.length; u++) {
            if (upcoming[u].hay.indexOf(key) !== -1) { match = upcoming[u]; break; }
          }
          if (match) {
            subEl.textContent = fmt(match);
          } else {
            var cur = norm(subEl.textContent).trim();
            /* only stamp TBA over empty or already-TBA-ish text — keep real static
               info (e.g. the weekly Pokémon Play schedule) as the fallback */
            if (!cur || cur.indexOf('to be announced') !== -1 || cur.indexOf('tba') === 0) {
              subEl.textContent = TBA;
            }
          }
        }
      })
      .catch(function () {}); /* offline / page missing: slides keep their static text */
  }

  if (document.readyState !== 'loading') run();
  else document.addEventListener('DOMContentLoaded', run);
})();
